import { render, staticRenderFns } from "./ModalBasic.vue?vue&type=template&id=704e7553&scoped=true"
import script from "./ModalBasic.vue?vue&type=script&lang=js"
export * from "./ModalBasic.vue?vue&type=script&lang=js"
import style0 from "./ModalBasic.vue?vue&type=style&index=0&id=704e7553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e7553",
  null
  
)

export default component.exports